<template>
  <div class="not-found-container">
    <div class="error-state">
      <h1>Page Not Found</h1>
      <p>This page is not available.</p>
      <router-link to="/">Return to Home</router-link>
    </div>
  </div>
</template>

<style scoped>
.not-found-container {
  text-align: center;
  padding: 80px 20px;
}

.error-state h1 {
  font-size: 32px;
  color: var(--color-text);
  margin-bottom: 15px;
}

.error-state p {
  font-size: var(--font-sm);
  color: color-mix(in srgb, var(--color-text) 75%, var(--color-bg));
  margin-bottom: 25px;
}

.error-state a {
  display: inline-block;
  padding: 12px 24px;
  background-color: var(--color-green);
  color: var(--color-accent-text);
  text-decoration: none;
  border-radius: var(--radius);
  transition: background-color var(--transition-base);
}

.error-state a:hover {
  background-color: var(--color-green-hover);
}
</style>
